import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  Renderer2,
} from "@angular/core";
import { fromEvent, Subscription } from "rxjs";

@Directive({
  selector: "[appScrollWithElement]",
  standalone: true,
})
export class ScrollWithElementDirective implements AfterViewInit, OnDestroy {
  @Input() listenToScrollElement: any;
  eventSubscription: Subscription;
  constructor(
    private element: ElementRef,
    private ngZone: NgZone,
    private renderer: Renderer2
  ) {}
  ngOnDestroy(): void {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }

  ngAfterViewInit() {
    // this.renderer.setElementStyle(this.element.nativeElement, 'transform', `translateX(${+(360)}px)`);
    this.eventSubscription = fromEvent(
      this.listenToScrollElement.element.nativeElement,
      "scroll"
    ).subscribe((e: MouseEvent) => {
      this.ngZone.runOutsideAngular(() =>
        requestAnimationFrame(() => {
          const scrollLeft =
            this.listenToScrollElement.element.nativeElement.scrollLeft;
          this.renderer.setStyle(
            this.element.nativeElement,
            "transform",
            `translateX(${-scrollLeft}px)`
          );
        })
      );
    });
  }
}
